/* eslint-disable import/no-extraneous-dependencies */
import React from 'react'
import { css, StyleSheet } from 'aphrodite/no-important'

import defaults from 'react-images/lib/theme'
import deepMerge from 'react-images/lib/utils/deepMerge'

const defaultStyles = {
  container: {
    alignItems: 'center',
    backgroundColor: defaults.container.background,
    boxSizing: 'border-box',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    left: 0,
    paddingBottom: defaults.container.gutter.vertical,
    paddingLeft: defaults.container.gutter.horizontal,
    paddingRight: defaults.container.gutter.horizontal,
    paddingTop: defaults.container.gutter.vertical,
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: defaults.container.zIndex,
  },
}

export default function Container(props) {
  const classes = StyleSheet.create(deepMerge(defaultStyles, {}))

  return (
    <div id="lightboxBackdrop" className={css(classes.container)} {...props} />
  )
}
